import { Controller } from '@hotwired/stimulus';

// Switches the API request example between its commented and bare forms, and
// keeps the copy button on whichever form is displayed.
export default class extends Controller {
  static targets = ['form', 'option', 'copy'];
  static values = { form: { type: String, default: 'annotated' } };

  connect() {
    this.apply();
  }

  select(event) {
    this.formValue = event.currentTarget.dataset.form;
  }

  formValueChanged() {
    this.apply();
  }

  apply() {
    if (!this.hasFormTarget) return;

    this.optionTargets.forEach((option) => {
      const active = option.dataset.form === this.formValue;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', String(active));
    });

    let shown = null;
    this.formTargets.forEach((form) => {
      const active = form.dataset.form === this.formValue;
      form.hidden = !active;
      if (active) shown = form;
    });

    if (shown && this.hasCopyTarget) {
      this.copyTarget.dataset.copyTextParam = shown.textContent;
    }
  }
}
